import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/UI/dialog';
import Button from '@/components/UI/Button';

export default function DeleteConfirmModal({ strategy, open, onClose, onConfirm }) {
  const [input, setInput] = useState('');
  const [deleting, setDeleting] = useState(false);

  const name = strategy?.name || '';
  const matches = input.trim() === name.trim();

  async function handleConfirm() {
    if (!matches) return;
    setDeleting(true);
    try {
      await onConfirm();
    } finally {
      setDeleting(false);
      setInput('');
    }
  }

  function handleClose() {
    setInput('');
    onClose();
  }

  return (
    <Dialog open={open} onOpenChange={(v) => !v && !deleting && handleClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-red-400">Permanently Delete Strategy</DialogTitle>
          <DialogDescription>
            This action <span className="font-semibold text-foreground">cannot be undone</span>. All historical data related to this strategy will be permanently lost, including:
          </DialogDescription>
        </DialogHeader>

        <ul className="text-xs text-muted-foreground space-y-1 pl-4 list-disc">
          <li>All orders and planned orders</li>
          <li>All trade history and fill records</li>
          <li>All position records and P&L data</li>
          <li>All executor run logs</li>
          <li>All notifications for this strategy</li>
        </ul>

        <div className="mt-4">
          <p className="text-sm text-muted-foreground mb-2">
            Type <span className="font-mono font-semibold text-foreground bg-accent/20 px-1.5 py-0.5 rounded">{name}</span> to confirm:
          </p>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Enter strategy name"
            className="w-full px-3 py-2 bg-background border border-border text-foreground rounded-lg text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500/50"
            autoFocus
          />
        </div>

        <DialogFooter className="mt-4">
          <Button variant="ghost" onClick={handleClose} disabled={deleting}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={!matches || deleting}
            className="bg-red-600 hover:bg-red-700 text-white disabled:opacity-40"
          >
            {deleting ? 'Deleting...' : 'Delete Permanently'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
